<template>
  <div class="content-modal">
    <div class="header-modal">
      Invoice Detail

      <div class="btn-close" @click.capture="closeInv">
        <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M76.4168 123.583L123.583 76.4166M123.583 123.583L76.4168 76.4166M100 183.333C145.833 183.333 183.333 145.833 183.333 100C183.333 54.1666 145.833 16.6666 100 16.6666C54.1668 16.6666 16.6667 54.1666 16.6667 100C16.6667 145.833 54.1668 183.333 100 183.333Z" stroke="white" stroke-width="14.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    </div>

    <div class="form-modal">
      <div class="detail-container">
        <div class="header-detail">
          <p>{{ dataDetail.income_type_name }}</p>
          <p>No INV: {{ dataDetail.invoice_no }}</p>
          <p></p>
        </div>

        <div class="content-detail">
          <table>
            <tr>
              <td>NIS</td>
              <td>:</td>
              <td>{{ dataDetail.nis }}</td>
            </tr>
            <tr>
              <td>Name</td>
              <td>:</td>
              <td>{{ dataDetail.name_siswa }}</td>
            </tr>
            <tr>
              <td>Department</td>
              <td>:</td>
              <td>{{ dataDetail.departname }}</td>
            </tr>
            <tr>
              <td>Class</td>
              <td>:</td>
              <td>{{ dataDetail.classname }}</td>
            </tr>
            <tr>
              <td>VA No.</td>
              <td>:</td>
              <td>{{ dataDetail.va_no }}</td>
            </tr>

            <br>
            <br>

            <tr>
              <td>Value</td>
              <td>:</td>
              <td class="interger-value">Rp <div class="rupiah-space">{{ formatIdr(dataDetail.income_value) }}</div></td>
            </tr>
            <tr>
              <td>Outstanding</td>
              <td>:</td>
              <td class="interger-value urgent-value">Rp <div class="rupiah-space">{{ formatIdr(dataDetail.outstanding) }}</div></td>
            </tr>

            <br>
            <br>

            <tr>
              <td>Invoice Date</td>
              <td>:</td>
              <td>{{ formatDate(dataDetail.invoice_date) }}</td>
            </tr>
            <tr>
              <td>Due Date</td>
              <td>:</td>
              <td class="urgent-value">{{ formatDate(dataDetail.due_date) }}</td>
            </tr>
            <tr>
              <td>Remarks</td>
              <td>:</td>
              <td>{{ dataDetail.remarks }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* eslint-disable */
  import { ref, reactive, onMounted, onUpdated, watchEffect } from 'vue';
  import dayjs from 'dayjs';

  export default {
    name: "Modal Detail",
    props: {
      propDetail: {
        type: Object,
        default: () => ({ empty: true }),
      },
    },
    emits: ["close-modal"],
    methods: {
      formatDate(dateString) {
        const date = dayjs(dateString);
        return date.format('D MMMM YYYY');
      },

      formatIdr: value => (value + '').replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    setup(props, { emit }) {
      const dataDetail = reactive({
        nis: '',
        name_siswa: '',
        departname: '',
        classname: '',
        income_type_name: '',
        invoice_date: '',
        invoice_no: '',
        income_value: '',
        outstanding: '',
        due_date: '',
        remarks: ''
      });

      const closeInv = (event, item) => {
        emit("close-click", event, item)
      }

      watchEffect(() => {
        const newdetail = props.propDetail;
        Object.assign(dataDetail, newdetail);
      });

      return {
        dataDetail,
        closeInv
      }
    }
  }
</script>
